export default "__VITE_ASSET__DvQO3HJ1__ 480w, __VITE_ASSET__DzPNWBoV__ 768w, __VITE_ASSET__DnL_domV__ 1200w, __VITE_ASSET__CZfNqbT2__ 1920w";